var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "discord",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.198,
    height: 55.198,
    viewBox: "0 0 55.198 55.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M26.753,0h1.692A26.753,26.753,0,0,1,55.2,26.753v1.692A26.753,26.753,0,0,1,28.445,55.2H26.753A26.753,26.753,0,0,1,0,28.445V26.753A26.753,26.753,0,0,1,26.753,0Z",
    fill: "#f7f7f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(14.464 13.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1625.207-143.337H1636a1.016,1.016,0,0,0,.236.071,3.157,3.157,0,0,1,2.844,3.1c-.022,8.371-.01,16.743-.01,25.114v.368l-6.894-5.9-.08.066.778,2.556h-.391q-8.132,0-16.265,0a7.265,7.265,0,0,1-.894-.056,2.884,2.884,0,0,1-2.509-2.8q-.008-9.8,0-19.609a2.618,2.618,0,0,1,.612-1.68,3.131,3.131,0,0,1,2.612-1.173c2.921.014,5.843.005,8.764,0A2.821,2.821,0,0,0,1625.207-143.337Zm-4.91,8.521a10.289,10.289,0,0,1,3.458-1.517c-.157-.349-.436-.238-.647-.215a7.71,7.71,0,0,0-3.6,1.379.966.966,0,0,0-.324.37c-.353.784-.721,1.564-1.02,2.369a18.183,18.183,0,0,0-1.066,5.169,1.366,1.366,0,0,0,.351,1.152,6,6,0,0,0,3.52,1.695,1.055,1.055,0,0,0,1.227-.544,6.2,6.2,0,0,1,.543-.678,5.584,5.584,0,0,1-2.393-1.435c.5.19.937.359,1.375.52a13.548,13.548,0,0,0,4.482.918,8.993,8.993,0,0,0,3.612-.679c.564-.235,1.111-.512,1.7-.783a5.735,5.735,0,0,1-2.428,1.371,6.27,6.27,0,0,1,.441.6,1.25,1.25,0,0,0,1.48.6,6.293,6.293,0,0,0,3.736-1.933.51.51,0,0,0,.125-.348c-.071-.846-.117-1.7-.253-2.534a18.092,18.092,0,0,0-1.85-5.476.864.864,0,0,0-.246-.3,7.751,7.751,0,0,0-3.867-1.441.4.4,0,0,0-.446.3,11.509,11.509,0,0,1,3.26,1.5A13.821,13.821,0,0,0,1620.3-134.816Z",
    transform: "translate(-1612.808 143.337)",
    fill: "#259e76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1625.819-123.569a1.87,1.87,0,0,1,1.881-1.939,1.92,1.92,0,0,1,1.869,1.937,1.944,1.944,0,0,1-1.9,1.95A1.891,1.891,0,0,1,1625.819-123.569Z",
    transform: "translate(-1617.233 137.296)",
    fill: "#259e76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1637.653-123.552a1.89,1.89,0,0,1-1.9,1.931,1.943,1.943,0,0,1-1.85-1.964,1.929,1.929,0,0,1,1.924-1.922A1.865,1.865,0,0,1,1637.653-123.552Z",
    transform: "translate(-1619.982 137.296)",
    fill: "#259e76"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.b248a6a9.svg";
export { ForwardRef as ReactComponent };